import { pushDataLayer } from '../_utilities/data-layer'

type PayloadValue = unknown | ((form: HTMLFormElement) => unknown)
type FormEventConfig = Record<string, PayloadValue>

const readCourseTitle = (form: HTMLFormElement): string => {
    const select = form.querySelector<HTMLSelectElement>('select[name*="[course]"]')
    if (select && select.selectedIndex >= 0) {
        return select.options[select.selectedIndex]?.text.trim() ?? ''
    }
    const checked = form.querySelector<HTMLInputElement>('input[name*="[course]"]:checked')
    if (checked) {
        const labelText = checked.closest('label')?.textContent
            ?? (checked.id ? form.querySelector<HTMLLabelElement>(`label[for="${checked.id}"]`)?.textContent : null)
        return labelText?.trim() ?? ''
    }
    return ''
}

// Map Formie form handles to GTM payloads. Values can be literals or
// functions that receive the form element (resolved at submit time).
const FORM_HANDLE_EVENTS: Record<string, FormEventConfig> = {
    contact: { event: 'conv_contact_submit' },
    brochureRequest: { event: 'conv_brochure_form_submit' },
    courseRegistration: { event: 'course_subscribe', course_title: readCourseTitle },
}

const isFinalFormieSubmit = (e: SubmitEvent): boolean => {
    const submitter = e.submitter as HTMLElement | null
    if (!submitter) return true
    if (submitter.classList.contains('fui-next')) return false
    const action = submitter.getAttribute('data-submit-action')
    return !action || action === 'submit'
}

document.addEventListener('submit', (e) => {
    const form = e.target as HTMLElement | null
    if (!(form instanceof HTMLFormElement)) return

    // Multi-step Formie forms fire `submit` on every step. Only the final-step
    // submit button lacks the `fui-next` class; back/save buttons have a
    // different `data-submit-action`. Skip everything but the real final submit.
    if (!isFinalFormieSubmit(e as SubmitEvent)) return

    const wrapper = form.closest<HTMLElement>('[data-form-handle]')
    const handle = wrapper?.dataset.formHandle
    const config = handle ? FORM_HANDLE_EVENTS[handle] : undefined
    if (!config) return

    const payload: Record<string, unknown> = {}
    for (const [key, value] of Object.entries(config)) {
        payload[key] = typeof value === 'function' ? value(form) : value
    }
    pushDataLayer(payload)
})
